import Axios from 'axios'
import router from '../../router'
import {authUrls} from '../defaults/.url'

export default {
  do_login (context, loginData) {
    const postData = {
      email: loginData.email,
      password: loginData.password
    }

    Axios.post(authUrls.login, postData).then(function (response) {
      localStorage.setItem('access_token', response.data.auth_token)
      localStorage.setItem('unem', JSON.stringify(response.data))
      context.dispatch('get_credentials')
    }).catch(function (error) {
      console.log(error)
    })
  },
  request_password_reset (context, data) {
    Axios.post(authUrls.request_reset, data).then(function (response) {
      localStorage.setItem('access_token', response.data.auth_token)
      router.push({
        name: 'Login'
      })
    }).catch(function (error) {
    })
  },
  reset_password (context, data) {
    Axios.post(authUrls.reset_password + data.reset_id, data).then(function (response) {
      localStorage.setItem('access_token', response.data.auth_token)
      window.location.replace('/login')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  get_credentials (context) {
    Axios.get(authUrls.user_details).then(function (response) {
      if (response.status !== 200) {
        alert('Wrong Credentials')
      } else {
    
        context.commit('GET_STATE', response.data)
        context.dispatch('find_view')
      }
    })
  },
  find_view (context) {
    let usertype_local = JSON.parse(localStorage.getItem('unem'))
    var usertype_id=usertype_local.user_type_id
    if (usertype_id =='230862f9'){
      window.location.replace('/bookings/inspection')
    }else{
      window.location.replace('/dashboard')
    }
    
  },
  reset_storage (context, trackerId) {
    Axios.get(authUrls._doLogout + trackerId).then(() => {
    })
    localStorage.clear()
    router.push({
      name: 'Login'
    })
  }
}
